<template>
    <div>
<!--        The group named "<strong>{{ $_.get(activity, "payload.name") }}</strong>" was added by-->
<!--        <strong>{{ $_.get(activity, "actorUser.name") }}</strong>.-->
        <span v-html="$t('notification.customerGroupAdded', {group: $_.get(activity, 'payload.name'), user: $_.get(activity, 'actorUser.name') })"></span>
    </div>
</template>
<script>
import Vue from "vue";

export default Vue.extend({
    name: "CustomerGroupAdded",
    props: {
        activity: {
            type: Object,
            default: () => ({}),
        },
    },
});
</script>

<style scoped lang="scss"></style>
